import { HStack, View, VStack } from "@gluestack-ui/themed";
import { PasswordStrengthProps } from "./types";
import { getIndicatorColorByPasswordStrength } from "./utils";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";

function PasswordStrength({
  hasMinCharacters,
  hasMinNumbers,
  hasMinLowercaseLetters,
  passwordStrengthValue
}: PasswordStrengthProps) {
  return (
    <VStack space="sm">
      <Text fontWeight={600} color="$secondary400" mb="$1" fontSize="$sm">
        Sua senha deve conter:
      </Text>
      <HStack alignItems="center" space="sm">
        <Icon
          name="check-circle"
          size={16}
          variant="regular"
          color={hasMinCharacters ? "$success600" : "$error500"}
        />
        <Text color="$secondary400" fontSize="$sm">
          No mínimo, 6 caracteres.
        </Text>
      </HStack>
      <HStack alignItems="center" space="sm">
        <Icon
          name="check-circle"
          size={16}
          variant="regular"
          color={hasMinNumbers ? "$success600" : "$error500"}
        />

        <Text color="$secondary400" fontSize="$sm">
          Pelo menos 4 números.
        </Text>
      </HStack>
      <HStack alignItems="center" space="sm">
        <Icon
          name="check-circle"
          size={16}
          variant="regular"
          color={hasMinLowercaseLetters ? "$success600" : "$error500"}
        />
        <Text color="$secondary400" fontSize="$sm">
          Pelo menos 2 letras minúsculas.
        </Text>
      </HStack>

      <VStack space="md" py="$4">
        <HStack flex={1} space="sm">
          <View
            flex={1}
            borderRadius="$full"
            minHeight="$2"
            minWidth="$12"
            bg={getIndicatorColorByPasswordStrength(0, passwordStrengthValue)}
          />
          <View
            flex={1}
            borderRadius="$full"
            minHeight="$2"
            minWidth="$12"
            bg={getIndicatorColorByPasswordStrength(1, passwordStrengthValue)}
          />
          <View
            flex={1}
            borderRadius="$full"
            minHeight="$2"
            minWidth="$12"
            bg={getIndicatorColorByPasswordStrength(2, passwordStrengthValue)}
          />
          <View
            flex={1}
            borderRadius="$full"
            minHeight="$2"
            minWidth="$12"
            bg={getIndicatorColorByPasswordStrength(3, passwordStrengthValue)}
          />

          <View
            flex={1}
            borderRadius="$full"
            minHeight="$2"
            minWidth="$12"
            bg={getIndicatorColorByPasswordStrength(4, passwordStrengthValue)}
          />
        </HStack>

        <Text color="$textLight600" fontSize="$sm">
          Força da senha
        </Text>
      </VStack>
    </VStack>
  );
}

export default PasswordStrength;
